import React, { useMemo, useState } from 'react';
import { useAdminClinicList } from 'infrastructure/hooks/clinic/use-admin-clinic-list';
import { useTranslation } from 'react-i18next';
import ChildrenIcon from 'assets/img/icons/childs.svg?react';
import CollapseAnimation from 'components/atoms/base-animations/collapse';
import ExpandButton from 'components/molecules/expand-button';
import { defaultCols } from 'components/molecules/clinics/table/cols/defaultColumns';
import BaseTableNew from 'components/atoms/base-table/new';

import s from './styles.module.scss';

interface IProps {
  parentGuid: string;
}

const ClinicsParentTable: React.FC<IProps> = ({ parentGuid }) => {
  const { t } = useTranslation();
  const [page, setPage] = useState<number>(1);
  const { loading, clinics, meta } = useAdminClinicList({
    meta: {
      guid: parentGuid,
      page,
      items: 10,
      onlyParents: true,
    },
  });
  const columns = useMemo(
    () => defaultCols({ page, hideParentTag: true, hidePosition: true }),
    [page],
  );

  const onChangePage = (newPage: number) => {
    setPage(newPage);
  };

  const [collapseChildrenTable, setCollapseChildrenTable] =
    useState<boolean>(false);
  const toggleCollapseChildrenTable = () =>
    setCollapseChildrenTable((prev) => !prev);

  const ChildsTableTitle = () => {
    return (
      <div className={s['table-header']}>
        <p>
          <ChildrenIcon
            width={20}
            style={{ marginBottom: 6, marginRight: 6, rotate: '90deg' }}
            height={20}
          />
          {t('labels.parentClinic')}{' '}
        </p>
        <ExpandButton
          expanded={collapseChildrenTable!}
          dataCy="toggle-children-btn"
          onClick={toggleCollapseChildrenTable}
        />
      </div>
    );
  };
  return (
    <div className={s.table}>
      <ChildsTableTitle />
      <CollapseAnimation opened={collapseChildrenTable!} className={s.collapse}>
        <BaseTableNew
          className={s['table-wrapper']}
          rowKey="guid"
          dataCy="clinics-table"
          bordered
          columns={columns ?? []}
          items={clinics}
          loading={loading}
          pagination={{
            current: page ?? 1,
            pageSize: meta.items,
            total: meta.totalCount,
          }}
          onChangePage={onChangePage}
          anchor
        />
      </CollapseAnimation>
    </div>
  );
};

export default ClinicsParentTable;
